import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget } from 'react-dnd'
import { differenceBy } from 'lodash'

import SortableItem from './sortable-item'
import './sortable-column.css'


const propTypes = {
  items: PropTypes.array.isRequired,
  itemType: PropTypes.string.isRequired,
  Element: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  setRef: PropTypes.func.isRequired,
  itemKey: PropTypes.string,
  useHandle: PropTypes.bool,
  axis: PropTypes.string,
  connectDropTarget: PropTypes.func,
  canDrop: PropTypes.bool,
  isOver: PropTypes.bool,

  /* eslint-disable react/no-unused-prop-types */
  moveColumn: PropTypes.func.isRequired,
  /* eslint-enable */
}

const defaultProps = {
  itemKey: 'id',
  useHandle: false,
  axis: 'y',

  connectDropTarget: (a) => a,
  canDrop: false,
  isOver: false,
}

const getType = ({ itemType }) => itemType

const columnTarget = {
  hover: (props, monitor) => {
    const { item: dragItem } = monitor.getItem()

    return props.columnIndex !== dragItem.columnIndex
  },
  drop: (props, monitor) => {
    const { item: dragItem } = monitor.getItem()

    props.moveColumn(dragItem, props.columnIndex)
  },
  canDrop: (props, monitor) => {
    const { item: dragItem } = monitor.getItem()

    return props.columnIndex !== dragItem.column
  },
}

@DropTarget(
  getType,
  columnTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver(),
  }),
)
class SortableColumn extends Component {
  constructor(props) {
    super(props)

    this.state = { items: props.items }
  }

  static getDerivedStateFromProps(props, state) {
    const { items, itemKey } = props
    const prevItems = state.items

    if (items.length > prevItems.length) {
      const newitems = differenceBy(items, prevItems, itemKey)
      return {
        ...state,
        items: [...newitems, ...state.items],
      }
    } if (items.length < prevItems.length) {
      const poppedItems = differenceBy(prevItems, items, itemKey).map((item) => item[itemKey])
      const newitems = state.items.filter((item) => !poppedItems.includes(item[itemKey]))

      return {
        ...state,
        items: newitems,
      }
    }

    return state
  }

  moveItem = (dragIndex, hoverIndex) => {
    if (dragIndex === hoverIndex) {
      return
    }

    const items = this.state.items.slice()

    items.splice(hoverIndex, 0, items.splice(dragIndex, 1)[0])

    this.setState({ items })
  }

  render() {
    const { items } = this.state
    const {
      itemKey,
      itemType,
      Element,
      useHandle,
      axis,
      connectDropTarget,
      canDrop,
      isOver,
      setRef,
      columnIndex,
    } = this.props

    let containerClass = 'fillColumn'

    if (canDrop && isOver) {
      containerClass += ' dropHover'
    }
    return connectDropTarget((
      <div className={containerClass} ref={setRef(columnIndex)}>
        {items.map((item, i) => (
          <SortableItem
            key={item[itemKey]}
            index={i}
            id={item[itemKey]}
            itemType={itemType}
            item={item}
            moveItem={this.moveItem}
            Element={Element}
            useHandle={useHandle}
            axis={axis}
            columnIndex={columnIndex}
          />
        ))}
      </div>
    ))
  }
}

SortableColumn.propTypes = propTypes

SortableColumn.defaultProps = defaultProps

export default SortableColumn
